"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScriptedQuote = exports.BuiltinQuote = exports.Quote = void 0;
const to_source_1 = require("./to-source");
class Quote {
}
exports.Quote = Quote;
class BuiltinQuote extends Quote {
    constructor(callback) {
        super();
        this.callback = callback;
    }
    call(context, print) {
        this.callback(context, print);
    }
    toSource() {
        return '("native quote")';
    }
}
exports.BuiltinQuote = BuiltinQuote;
class ScriptedQuote extends Quote {
    constructor(nodes) {
        super();
        this.nodes = nodes;
    }
    call(context, print) {
        context.exec(this.nodes, print);
    }
    toSource() {
        return `(${this.nodes.map((node) => (0, to_source_1.nodeToSource)(node)).join(" ")})`;
    }
}
exports.ScriptedQuote = ScriptedQuote;
